import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import ReactImageFallback from 'react-image-fallback'
import imagefallback from '@loyal_images/products/product_placeholder.png'
import ProductTabs from './ProductTabs'
import MediaQuery from 'react-responsive'
import { ClickCopy } from 'react-click-copy-code'
import { ComunidadeIuppService as Service } from '../../Services/ComunidadeIupp'

import Rater from 'react-rater'
import Modal from 'react-awesome-modal'
import { ModalEvaluation } from './ModalEvaluation'
import { ModalReport } from './ModalReport'

import 'react-rater/lib/react-rater.css'
import 'react-tabs/style/react-tabs.css'
import '@loyal_template/rating.css'

class Product extends Component {
  constructor (props) {
    super(props)

    this.state = {
      copied: false,
      modalGoLink: false,
      onClose: false,
      unity: null,
      isLoaded: false,
      currentPage: 0,
      onReportToggle: false,
      complain: {},
      errorReportComplain: false,
      Evaluate: {},
      EvaluateItems: [],
      offer: {},
      filter: {
        pagination: {
          pageSize: 1,
          pageNumber: 1
        },
        filter: {
          saleId: this.props.product,
          storeIds: [this.props.store],
          geoNear: {
            maxDistance: 500000,
            location: {
              latitude: -23.4945212,
              longitude: -46.7066441
            }
          }
        }
      }
    }
    this.onCopy = this.onCopy.bind(this)
    this.modalGoLink = this.modalGoLink.bind(this)
    this.onRating = this.onRating.bind(this)
    this.ReportToggle = this.ReportToggle.bind(this)
    this.handleGetEvaluate = this.handleGetEvaluate.bind(this)
    this.handleClickModalRedirect = this.handleClickModalRedirect.bind(this)
    this.createEvaluate = this.createEvaluate.bind(this)
  }

  componentDidMount () {
    this.handleVerifyToken()
    this.handleGetUnity()
    this.handleGetComplain()
    this.handleGetEvaluate(5, 1)
    this.handleGetOffer()
  }

   handleVerifyToken = async () => {
     await Service.tokenVerify()
   }

   handleGetUnity = async () => {
     const resultUnity = await Service.getUnity(this.props.company, this.props.store)
     if (resultUnity != null) {
       this.setState({
         ...this.state,
         isLoaded: true,
         unity: resultUnity.data.objectReturn })
     }
   }
   handleGetOffer = async () => {
     const resultOffer = await Service.getOffers(this.state.filter)
     this.setState({ offer: resultOffer.data.objectReturn.data[0] })
   }
   handleGetEvaluate= async (items = 5, page = 1) => {
     const resultEvaluate = await Service.getEvaluate(this.props.company, items, page)

     const averageRating = resultEvaluate.data.objectReturn && resultEvaluate.data.objectReturn.averageRating
     const numberOfRows = resultEvaluate.data.objectReturn && resultEvaluate.data.objectReturn.numberOfRows
     const Evaluate = {
       'averageRating': averageRating,
       'numberOfRows': numberOfRows
     }
     const EvaluateItems = this.state.EvaluateItems.concat(resultEvaluate.data.objectReturn.ratings)
     this.setState({ currentPage: (this.state.currentPage + 1), Evaluate: Evaluate, EvaluateItems: EvaluateItems })
     return resultEvaluate
   }
   createEvaluate= async (EvaluateTitle, EvaluateComment, EvaluateRating, EvaluateUserId, EvaluateName) => {
     const payload = {
       'comment': EvaluateComment,
       'title': EvaluateTitle,
       'rating': EvaluateRating,
       'userId': this.props.company,
       'participantIdentifier': EvaluateUserId,
       'participantName': EvaluateName
     }
     const resultEvaluate = await Service.createEvaluate(payload)

     this.setState({ EvaluateItems: [], Evaluate: {} })
     this.handleGetEvaluate(5, 1)

     return resultEvaluate
   }
   onCopy () {
     this.setState({ copied: true })
     setTimeout(() => {
       this.setState({ copied: false })
       this.modalGoLink()
     }, 1000)
   }

   handleClickModalRedirect () {
     this.state.unity.urlECommerce ? window.open(this.state.unity.urlECommerce, '_blank') : this.modalGoLink()
   }

   modalGoLink () {
     this.setState({ modalGoLink: !this.state.modalGoLink })
   }
   onRating () {
     this.setState({ onClose: !this.state.onClose })
   }

   ReportToggle () {
     this.setState({ onReportToggle: !this.state.onReportToggle })
   }
   toReport = async (email, id, description) => {
     const payload = {
       'complainTypeId': id,
       'company': this.state.unity.description,
       'description': description,
       'email': email,
       'userId': this.props.company
     }
     const resultComplain = await Service.createReportComplain(payload)
     if (resultComplain && resultComplain.data && resultComplain.data.success) {
       this.ReportToggle()
       return resultComplain
     } else {
       this.setState({ errorReportComplain: true })
       return resultComplain
     }
   }
   handleGetComplain = async () => {
     const resultComplain = await Service.getComplain()
     this.setState({ complain: resultComplain && resultComplain.data.objectReturn })
   }

   render () {
     const props = this.props
     return (
       this.state.isLoaded === false ? ''
         : <Fragment>
           <div className='container-bairro container pt-5 pb-3 ' data-sku={props.company}>
             <div className='row'>

               <div className='bairro-side col-12 col-md-7 pr-0 pl-0 pl-md-1 pr-md-2'>
                 <div className='border-ui-3 radius bg-white pt-1 pt-md-3 pos-relative'>
                   <div className={`bairro-image overflow voucher txt-center`}>
                     <ReactImageFallback
                       src={this.state.offer.urlImage}
                       fallbackImage={imagefallback}
                       initialImage={imagefallback}
                       alt={''}
                       className='mx-auto'
                     />
                   </div>

                   <MediaQuery minDeviceWidth={768}>
                     <ProductTabs
                       description={this.state.unity.descriptionChain}
                       evaluate={this.state.Evaluate}
                       evaluateItems={this.state.EvaluateItems}
                       onRating={this.onRating}
                       handleGetEvaluate={this.handleGetEvaluate}
                       currentPage={this.state.currentPage}
                       offer={this.state.offer}
                     />
                   </MediaQuery>
                 </div>
               </div>

               <div className='bairro-side col-12 col-lg-5  mt-4 mt-lg-0'>
                 <div className='row border-ui-3 radius bg-white px-0 py-0'>
                   <div className='bairro-infos col-12 py-2 px-3 mx-0'>
                     <p className='txt-body color-featured mb-1 txt-lowercase'>
                       {this.state.unity.category}
                     </p>
                     <h2 className='color-title'>
                       {this.state.offer.fantasyName} {!this.state.offer.isVirtualStore ? ' - ' + this.state.unity.description : ''}
                     </h2>
                     <p className='txt-body-sm'>
                       {this.state.unity.address.city}/{this.state.unity.address.state}
                     </p>
                     <div className='row align-items-center mt-half'>
                       <div className='col-auto product-rating'>
                         <p className='txt-subtitle'>
                           <strong>{this.state.Evaluate.averageRating}</strong>
                         </p>
                       </div>
                       <div className='col-auto product-rating px-0'>
                         <p>
                           <Rater total={5} rating={Math.round(this.state.Evaluate.averageRating)} interactive={false} />
                         </p>
                       </div>
                       <div className='col-auto product-rating'>
                         <p className='txt-body-sm'>
                           { this.state.Evaluate.numberOfRows > 1 ? this.state.Evaluate.numberOfRows + ' avaliações' : this.state.Evaluate.numberOfRows + ' avaliação' }
                         </p>
                       </div>
                     </div>
                   </div>
                   <div className='bairro-discount-infos col-12 border-color-ui-3 border-bottom border-top py-2 px-2'>
                     <div className='row w-100 mx-0'>
                       <div className='col-12'>
                         <div className='row'>
                           <div className='bairro-discount-value col-12 txt-left'>
                             <p className='txt-title txt-font-body-bold '>{this.state.offer.name !== undefined && this.state.offer.name !== '' ? this.state.offer.name + ' - ' : ''}  {this.state.offer.benefitTitle}</p>
                           </div>
                         </div>
                       </div>
                       { this.state.offer.isCupom ? (this.state.offer.isVirtualStore
                         ? <div className='col-12 mt-2 mb-1'>
                           <p className='txt-body-sm color-ui-1'>Copie o cupom e acesso o site para utilizar</p>
                         </div> : <div className='col-12 mt-2 mb-1'>
                           <p className='txt-body-sm color-ui-1'>Informe o cupom no momento da compra</p>
                         </div>) : ''}
                       { this.state.offer.isCupom
                         ? <div className='bairro-coupon col-12'>
                           <div className={`col-12 radius py-1 txt-center ${this.state.copied && 'copied'}`}>
                             <p>{this.state.offer.cupom}</p>
                           </div>
                         </div> : ''
                       }
                       { this.state.offer.isGift
                         ? <div className='col-12 mt-2 mb-1'>
                           <p className='txt-body-sm color-ui-1'>Brinde:</p>
                         </div> : ''}
                       { this.state.offer.isGift
                         ? <div className='bairro-coupon col-12'>
                           <div className={`col-12 radius py-1 txt-center ${this.state.copied && 'copied'}`}>
                             <p>{this.state.offer.gift}</p>
                           </div>
                         </div> : ''
                       }
                       { this.state.offer.isCupom && this.state.offer.isVirtualStore
                         ? <div className='col-12 mt-2'>
                           <ClickCopy sourceOverwrite={this.state.offer.cupom} onClick={this.onCopy} className='btn btn-featured btn-copy-coupon col-12 col-md-12 px-3'>
                             Copiar cupom e utilizar
                           </ClickCopy>
                         </div> : ''}
                       { this.state.offer.isGift && this.state.offer.isVirtualStore
                         ? <div className='col-12 mt-2'>
                           <ClickCopy sourceOverwrite={this.state.offer.cupom} onClick={this.onCopy} className='btn btn-featured btn-copy-coupon col-12 col-md-12 px-3'>
                             Acessar site
                           </ClickCopy>
                         </div> : ''}
                     </div>
                   </div>
                   <div className='bairro-contact-info col-12 border-color-ui-3 border-bottom border-top px-1'>
                     <div className='row py-2'>
                       <div className='col-12 px-2'>
                         { !this.state.offer.isVirtualStore && this.state.unity.description && <div className='bairro-contact-item row mx-0 align-items-center'>
                           <div className='col-auto'>
                             <i className='icon icon_chat' />
                           </div>
                           <div className='col-auto'>
                             <div className='row'>
                               <div className='col-12'>
                                 <p className='txt-subtitle color-ui-2'>Sobre</p>
                               </div>
                               <div className='col-12'>
                                 <p className='txt-body-sm color-ui-1'>{this.state.unity.description}</p>
                               </div>
                             </div>
                           </div>
                         </div> }
                         { this.state.unity.urlECommerce && <div className='bairro-contact-item row mx-0 align-items-center'>
                           <div className='col-auto'>
                             <i className='icon icon_translate' />
                           </div>
                           <div className='col-auto'>
                             <div className='row'>
                               <div className='col-12'>
                                 <p className='txt-subtitle color-ui-2'>site</p>
                               </div>
                               <div className='col-12'>
                                 <p className='txt-body-sm color-ui-1'><a href={this.state.unity.urlECommerce} target='_blank'>{this.state.unity.urlECommerce}</a></p>
                               </div>
                             </div>
                           </div>
                         </div> }
                         {!this.state.offer.isVirtualStore && this.state.unity.phone && <div className='bairro-contact-item row mx-0 align-items-center'>
                           <div className='col-auto'>
                             <i className='icon icon_phone' />
                           </div>
                           <div className='col-auto'>
                             <div className='row'>
                               <div className='col-12'>
                                 <p className='txt-subtitle color-ui-2'>telefone</p>
                               </div>
                               <div className='col-12'>
                                 <p className='txt-body-sm color-ui-1'>{this.state.unity.phone.length === 12 ? this.state.unity.phone.replace(/^(\d{2})(\d{4})(\d{4})$/g, '($1) $2-$3') : this.state.unity.whatsApp.replace(/^(\d{2})(\d{5})(\d{4})$/g, '($1) $2-$3') }</p>
                               </div>
                             </div>
                           </div>
                         </div> }
                         {!this.state.offer.isVirtualStore && this.state.unity.whatsApp && <div className='bairro-contact-item row mx-0 align-items-center'>
                           <div className='col-auto'>
                             <i className='icon icon_whatsapp' />
                           </div>
                           <div className='col-auto'>
                             <div className='row'>
                               <div className='col-12'>
                                 <p className='txt-subtitle color-ui-2'>whatsapp</p>
                               </div>
                               <div className='col-12'>
                                 <p className='txt-body-sm color-ui-1'><a href={'https://api.whatsapp.com/send?phone=55' + this.state.unity.whatsApp} target='_blank'>{this.state.unity.whatsApp.replace(/^(\d{2})(\d{5})(\d{4})$/g, '($1) $2-$3')}</a></p>
                               </div>
                             </div>
                           </div>
                         </div>}
                         {!this.state.offer.isVirtualStore && this.state.unity.instagram && <div className='bairro-contact-item row mx-0 align-items-center'>
                           <div className='col-auto'>
                             <i className='icon icon_instagram' />
                           </div>
                           <div className='col-auto'>
                             <div className='row'>
                               <div className='col-12'>
                                 <p className='txt-subtitle color-ui-2'>instagram</p>
                               </div>
                               <div className='col-12'>
                                 <p className='txt-body-sm color-ui-1'>{this.state.unity.instagram}</p>
                               </div>
                             </div>
                           </div>
                         </div>}
                         {!this.state.offer.isVirtualStore && this.state.unity.address.zipCode && this.state.unity.address.street && this.state.unity.address.city && (<div className='bairro-contact-item row mx-0 align-items-center'>
                           <div className='col-auto'>
                             <i className='icon icon_location' />
                           </div>
                           <div className='col-auto'>
                             <div className='row'>
                               <div className='col-12'>
                                 <p className='txt-subtitle color-ui-2'>endereço</p>
                               </div>
                               <div className='col-12'>
                                 <p className='txt-body-sm color-ui-1'>{this.state.unity.address.street}, {this.state.unity.address.number} - {this.state.unity.address.neighborhood}</p>
                                 <p className='txt-body-sm color-ui-1'>{this.state.unity.address.city} - {this.state.unity.address.state} - {this.state.unity.address.zipCode.replace(/^(\d{5})(\d{3})$/g, '$1-$2')}</p>
                               </div>
                             </div>
                           </div>
                         </div>)}
                       </div>
                     </div>
                     <div className='row align-items-center bg-ui-4 border-top border-color-ui-3'>
                       <div className='col-12 px-2 py-1'>
                         <p className='txt-body-sm mBairro'>Caso tenha algum problema com este anúncio e queira denunciá-lo <span className='txt-body-sm cursor color-featured' onClick={this.ReportToggle}>clique aqui</span>.</p>
                       </div>
                     </div>
                   </div>
                   <MediaQuery maxDeviceWidth={767}>
                     <ProductTabs
                       description={this.state.unity.descriptionChain}
                       onRating={this.onRating}
                       evaluate={this.state.unity.evaluate}
                       evaluateItems={this.state.EvaluateItems}
                       handleGetEvaluate={this.handleGetEvaluate}
                       currentPage={this.state.currentPage}
                       offer={this.state.offer}
                     />
                   </MediaQuery>
                 </div>
               </div>

             </div>
           </div>

           <div className=' modal-marker'>
             <Modal width='100%' height='100%' effect='fadeInUp' visible={this.state.modalGoLink}>
               <div className='container h-100'>
                 <div className='row align-items-center h-100'>
                   <div className='modal-copy-and-go col-auto mx-auto bg-white radius '>
                     <div className='row'>
                       <div className='col-12 py-2 px-2 border-bottom border-color-ui-3'>
                         <h2 className='py-half'>você será enviado ao site do nosso parceiro</h2>
                       </div>
                       <div className='col-12 py-2 px-2'>
                         <div className='row align-items-center'>
                           <div className='col-auto'>
                             <i className='icon icon_card color-brand-1' />
                           </div>
                           <div className='col'>
                             <p>não esqueça de realizar a compra com o seu Itaucard para garantir o desconto.</p>
                           </div>
                         </div>
                       </div>
                       <div className='col-12 py-2 px-2'>
                         <div className='row'>
                           <div className='col-6'>
                             <button className='btn' onClick={this.modalGoLink}>Cancelar</button>
                           </div>
                           <div className='col-6'>
                             <button className='btn btn-featured' onClick={this.handleClickModalRedirect}>Ir para o site</button>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </Modal>
           </div>
           <ModalReport
             show={this.state.onReportToggle}
             ReportToggle={this.ReportToggle}
             toReport={this.toReport}
             complain={this.state.complain}
             errorReportComplain={this.state.errorReportComplain}
           />
           <ModalEvaluation
             show={this.state.onClose}
             onClose={this.onRating}
             createEvaluate={this.createEvaluate}
           />
         </Fragment>)
   }
}

Product.propTypes = {
  product: PropTypes.string.isRequired,
  store: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired
}
export default (Product)



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Product/Product.js